import SEGMENT_EVENTS from 'constants/segmentEvents';

function Ctrl($rootScope, $scope, $state, jsSdkBooking, bookingHelpers, tracking) {
  $scope.$watch('booking', booking => {
    if (!booking) return;

    $scope.bookingUser = bookingHelpers.findBookingUser(booking);
  });

  $scope.confirmJoin = function() {
    jsSdkBooking.authorize($scope.booking.id, {
      userId: $rootScope.currentUser.id,
      paymentProfileId: $scope.paymentProfile.id
    }).then(function success(resp) {

      tracking.trackEvent(SEGMENT_EVENTS.JoinedOrder, {});

      $state.go('app.receipt', {
        booking: resp.id
      }, {
        reload: true
      });
    }, function error(response) {
      $scope.error = response.data;
    });
  };
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  '$state',
  'jsSdk.booking',
  'bookingHelpersService',
  'trackingService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/bookingStatus/controller.js